import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'footer-layout',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

}
